export default __webpack_public_path__ + "static/media/pizza.909ba0f5.png";